<template>
  <div style="height:100%">
    <portal to="app-header">
      Line Summary
      <shift-selector v-if="currentDate && shiftList.length" />
      <v-tooltip bottom v-if="!isMobile">
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-on="on"
            v-bind="attrs"
            class="ml-2"
            :disabled="loading"
            @click="getDashboardData"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        {{ $t('lastRefreshed') }} <strong>{{ lastRefreshedAt }}</strong>
      </v-tooltip>
    </portal>
    <v-row v-if="currentDate">
    <v-col cols="12">
      <oee-summary  @open-dialog="showDialog"/>
    </v-col>
    <!-- Fullscreen dialog for production or downtime -->
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
  <v-card>
    <v-toolbar dense dark color="primary">
      <v-toolbar-title>
        {{ selectedView === 'production' ? 'Shift Production' : 'Shift Downtime' }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-4">
      <component :is="selectedViewComponent" />
    </v-card-text>
  </v-card>
</v-dialog>

  </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ShiftSelector from './ShiftSelector.vue';
import OeeSummary from './widgets/OeeSummary.vue';
import ShiftProduction from './widgets/ShiftProduction.vue';
import ShiftDowntime from './widgets/ShiftDowntime.vue';

export default {
  name: 'ProductionSupervisorDashboard',
  components: {
    ShiftSelector,
    OeeSummary,
    ShiftProduction,
    ShiftDowntime,
  },
  data() {
    return {
      fetching: false,
      dialog: false,
      selectedView: '',
    };
  },
  async created() {
    this.fetching = true;
    await this.getBusinessTime();
    await Promise.all([
      this.getShifts(),
      this.getMachines(),
      this.fetchMachines(),
      this.getOperators(),
      this.getRejectionReasons(),
      this.getDowntimeReasons(),
    ]);
    this.fetching = false;
  },
  computed: {
    ...mapState('kpiDashboard', [
      'currentDate',
      'lastRefreshedAt',
      'loading',
    ]),
    selectedViewComponent() {
      if (this.selectedView === 'production') return 'shift-production';
      if (this.selectedView === 'downtime') return 'shift-downtime';
      return null;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    ...mapGetters('kpiDashboard', ['shiftList']),
  },
  methods: {
    ...mapActions('kpiDashboard', [
      'getBusinessTime',
      'getShifts',
      'getMachines',
      'fetchMachines',
      'getOperators',
      'getRejectionReasons',
      'getDowntimeReasons',
      'getDashboardData',
    ]),
    showDialog(view) {
      this.selectedView = view;
      this.dialog = true;
    },
  },
};
</script>
